// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.partner-area .container {\n    max-width: 1400px;\n}\n.ptb-64 {\n    padding-top: 65px;\n    padding-bottom: 45px;\n}\n\n", ""]);
// Exports
module.exports = exports;
